<template>
    <transition name="trs-simple-fade">
        <div class="header-search"
                itemscope
                itemtype="https://schema.org/WebSite"
                v-if="isVisible"
                @click.stop>
            <meta itemprop="url" :content="siteUrl">
            <form itemprop="potentialAction"
                    itemscope
                    itemtype="https://schema.org/SearchAction"
                    :action="action"
                    :type="type">
                <meta itemprop="target" :content="searchURISchema">
                <div class="header-search--row">
                    <div class="header-search--top-wrap">
                        <div class="header-search--col__side header-search--col">
                            <button class="header-search--submit" type="submit">
                                <ui-icon symbol="search" size="medium"/>
                            </button>
                        </div>
                        <div class="header-search--col__main header-search--col">
                            <input class="header-search--input"
                                    required
                                    itemprop="query-input"
                                    type="search"
                                    :name="name"
                                    :placeholder="placeholder"
                                    ref="input"
                                    @keyup="detectEasterEgg">
                        </div>
                        <div class="header-search--col__tail header-search--col">
                            <button class="header-search--close"
                                    :aria-label="searchButtonTitle"
                                    :title="searchButtonTitle"
                                    @click.prevent="hide">
                                <ui-icon symbol="close" :size="closeIconSize"/>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            <div class="header-search--row">
                <div class="header-search--col__side header-search--col"/>
                <div class="header-search--col__main header-search--col">
                    <nav class="header-search--quick-links">
                        <h2 class="header-search--title u-reset">
                            {{ quickLinksTitle }}
                        </h2>
                        <ul class="header-search--collection u-reset">
                            <li class="header-search--item"
                                    v-for="(link, index) in quickLinks"
                                    :key="index">
                                <a class="header-search--link u-reset" :style="getItemCss(index)" :href="link.path">{{
                                    link.label }}</a>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import bemMixin from '@dreipol/vue-ui/src/mixins/bem';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import { mapActions, mapState } from 'vuex';
    import { add as addEvent, remove as removeEvent } from 'bianco.events';
    import isMobileMixin from 'framework/mixins/is-mobile';
    import { subscribe, unsubscribe } from 'util/misc/overlay-tracker';
    import { eggs } from 'framework/vuex/modules/easter-egg/eggs';

    const ANIMATION_DELAY = 300; // ms
    const ANIMATION_STAGGER = 25;

    export default {
        components: {
            UiIcon,
        },
        mixins: [bemMixin('header-search'), isMobileMixin],
        props: {
            placeholder: {
                type: String,
                required: true,
            },
            quickLinksTitle: {
                type: String,
                required: true,
            },
            siteUrl: {
                type: String,
                required: true,
            },
            searchButtonTitle: {
                type: String,
                required: true,
            },
            /** @type ILink[] **/
            quickLinks: {
                type: Array,
                required: true,
            },
            type: {
                type: String,
                required: true,
            },
            name: {
                type: String,
                required: true,
            },
            action: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...mapState('header-search', ['isVisible']),
            closeIconSize() {
                return this.isMobile ? 'small' : 'medium';
            },
            searchURISchema() {
                return `${ this.action }?q={q}`;
            },
        },
        methods: {
            ...mapActions('header-search', ['hide']),
            getItemCss(index) {
                return {
                    animationDelay: `${ ANIMATION_STAGGER * (index + 1) + ANIMATION_DELAY }ms`,
                };
            },
            detectEasterEgg(e) {
                const { value } = e.currentTarget;

                if (eggs.includes(value)) {
                    this.enableEasterEgg({ name: value });
                }
            },
            ...mapActions('easter-egg', {
                enableEasterEgg: 'enable',
            }),
        },
        watch: {
            isVisible(value) {
                if (value) {
                    setTimeout(() => {
                        this.$refs.input.focus();
                    }, ANIMATION_DELAY);
                }
            },
        },
        mounted() {
            subscribe(this, this.hide);
            addEvent(window, 'click', () => this.hide());
        },
        beforeDestroy() {
            unsubscribe(this);
            removeEvent(window, 'click', this.hide);
        },
    };
</script>
